// extracted by mini-css-extract-plugin
export var divider = "_sr-0";
export var systemMessage = "_sr-1";
export var systemMessageWrapper = "_sr-2";